import { distance2 } from "@/math/coordinates";
import { longClick, longClickDist } from "@/model/Settings";
import { initViewportCoord } from "@/model/coordinates";
import { clientCoord } from "@/utils/dom/coordinates";

/**
 * Wraps a native `dblclick` handler so it only fires when the second click was a
 * quick, stationary tap.
 */
export function useSafeDoubleClick(onDoubleClick: (e: MouseEvent) => void) {
  let downTime = 0;
  let pos = initViewportCoord();
  let wasDoubleClick = true;

  function down(e: PointerEvent) {
    downTime = e.timeStamp;
    pos = clientCoord(e);
  }

  function up(e: PointerEvent) {
    const dist = distance2(pos, clientCoord(e));
    wasDoubleClick = e.timeStamp - downTime <= longClick && dist <= longClickDist;
  }

  function doubleClick(e: MouseEvent) {
    if (wasDoubleClick) {
      onDoubleClick(e);
    }
  }

  // pointerdownCapture so children that `@pointerdown.stop` (bubble)
  // can't hide the press and leave the tap check on stale coords.
  return { pointerdownCapture: down, pointerup: up, dblclick: doubleClick };
}
